import { getAppFeatures } from '@utils/getAppFeatures'
import { useEffect } from 'react'

export const useAppTitle = (): void => {
  const features = getAppFeatures()

  useEffect(() => {
    // Set the document title
    document.title = features?.info?.longName

    // Cleanup function to reset the title when the component unmounts (optional)
    return () => {
      document.title = '' // or any other default title
    }
  }, [features?.info?.longName])
}
